import conn from "@/store/utils/connection";
import depositAPI from "@/store/utils/api-route/depositAPI";
import resulter from "@/store/utils/resulter";
import state from "./state"

const actions = {
	async fetchListPaketDeposit({commit, rootGetters}, id) {
		try {
			let getFilter = rootGetters["filterGlobalModule/getFilter"]
			let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

			// let query = "idkonsumen=" + id
			// query += (!getFilterItem.paketKedaluarsa)
			// 	? "&kadaluarsa=1"
			// 	: "&kadaluarsa=0"
			// query += "&sort_by=" + getFilter.sortBy
			// 	+ "&order_by=" + getFilter.orderBy
			// query += "&limit=" + state.pagination.limit
			// 	+ "&offset=" + state.pagination.offset
			let query = {
				idkonsumen: id,
				kadaluarsa: !getFilterItem.paketKedaluarsa ? 1 : 0,
				sort_by: getFilter.sortBy,
				order_by: getFilter.orderBy,
				limit: state.pagination.limit,
				offset: state.pagination.offset,
			}

			// layanan terhubung
			if (getFilterItem.layananTerhubung.length > 0) {
				query.layanan_array = []
				getFilterItem.layananTerhubung.forEach((layananTerhubung) => {
					// query += "&layanan_array=" + layananTerhubung
					query.layanan_array = [...query.layanan_array, layananTerhubung]
				})
			}

			// masa aktif
			if (getFilterItem.masaAktif.length > 0) {
				query.masa_aktif_array = []
				getFilterItem.masaAktif.forEach((masaAktif) => {
					// query += "&masa_aktif_array=" + masaAktif
					query.masa_aktif_array = [...query.masa_aktif_array, masaAktif]
				})
			}

			const res = await conn.get(depositAPI.list.paketKonsumen, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setListPaketDeposit", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListPaketDepositOwnerAll({commit}, idoutlets) {
		// if (state.listPaketDepositOwner.data !== undefined) {
		// 	if (state.listPaketDepositOwner.data.length > 0) {
		// 		return resulter.successResult()
		// 	}
		// }

		try {
			let query = {
				sort_by: "nama",
				order_by: "ASC",
				// limit: 1000,
				// offset: 0,
			}
			if (idoutlets.length > 0) {
				query.idoutlet_array = idoutlets
			}
			const res = await conn.get(depositAPI.list.paketOwnerTiny, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListPaketDepositOwner", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchTransaksitDeposit({commit}, payload) {
		try {
			let query = {
				idkonsumen: payload.idcustomer,
				iddeposit: payload.iddeposit,
				tipe: payload.tipe,
				limit: state.pagination.limit,
				offset: state.pagination.offset
			}

			const res = await conn.get(depositAPI.list.transaksi, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setListTransaksiDeposit", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async filterTopupDeposit({commit, rootGetters}) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		const getFilterItem = JSON.parse(JSON.stringify(await rootGetters["filterGlobalModule/getFilterItem"]))

		let query = {
			sort_by: getFilter.sortBy,
			order_by: getFilter.orderBy,
			limit: state.pagination.limit,
			offset: state.pagination.offset,
		}

		// periode
		if (getFilterItem.periode.filterBy !== "") {
			query.filter_by = getFilterItem.periode.filterBy

			switch (getFilterItem.periode.filterBy) {
				case "periode":
					query.tanggal_awal = getFilterItem.periode.startDate
					query.tanggal_akhir = getFilterItem.periode.endDate
					break;
				case "bulan":
					query.bulan = getFilterItem.periode.month
					break;
				case "tahun":
					query.tahun = getFilterItem.periode.year
					break;
				default:
					break;
			}
		}
		// outlet
		if (getFilterItem.outlet.length > 0) {
			query.outlet_array = getFilterItem.outlet
		}
		// deposit
		if (getFilterItem.deposit.length > 0) {
			query.deposit_array = getFilterItem.deposit
		}
		// pembuat nota
		if (getFilterItem.karyawan !== "") {
			query.karyawan = getFilterItem.karyawan
		}
		// search
		if (state.isSearchTopup) {
			query.key = state.searchTopup.key
		}
		return query
	},
	async fetchListTopUpDeposit({commit, dispatch}) {
		try {
			const query = await dispatch("filterTopupDeposit")
			const res = await conn.get(depositAPI.list.topup, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setListTopupDeposit", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async fetchInfoTopUpDeposit({commit, dispatch}) {
		try {
			const query = await dispatch("filterTopupDeposit")
			const res = await conn.get(depositAPI.info, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setInfoTopupDeposit", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchDetailTopupDeposit({commit}, id) {
		try {
			let query = {idtransaksi: id}
			const res = await conn.get(depositAPI.detail, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailTopupDeposit", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async refundDeposit({commit}, payload) {
		try {
			let form = new FormData()
			form.append("idpembeliandeposit", payload.id)
			if (payload.keterangan !== "") form.append("keterangan", payload.keterangan)
			const res = await conn.post(depositAPI.refund, form, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async refundDepositV2({commit}, payload) {
		try {
			let form = new FormData()
			form.append("idpembelian_deposit", payload.id)
			if (payload.keterangan !== "") form.append("keterangan", payload.keterangan)
			form.append("data_refund_json", payload.dataRefund)
			payload.voidData.forEach(v => {
				v.file.forEach(file => {
					form.append("bukti_void_" + v.idbayar + "[]", file)
				})
			})
			const res = await conn.post(depositAPI.refundV2, form, conn.contentType.multipart)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async setujuiPermintaanHapus({commit}, payload) {
		try {
			let form = new FormData()
			form.append("idpermintaanhapus", payload.idpermintaanhapus)
			form.append("idpembelian_deposit", payload.id)
			if (payload.keterangan !== "") form.append("keterangan_status", payload.keterangan)
			form.append("data_refund_json", payload.dataRefund)
			payload.voidData.forEach(v => {
				v.file.forEach(file => {
					form.append("bukti_void_" + v.idbayar + "[]", file)
				})
			})
			const res = await conn.post(depositAPI.permintaanHapus, form, conn.contentType.multipart)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async export({commit, dispatch}, payload) {
		try {
			const query = await dispatch("filterTopupDeposit")
			let formData = new FormData
			formData.append("type", payload.type)
			formData.append("filter_json", JSON.stringify(query))

			const res = await conn.post(depositAPI.export.job, formData, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				let keyExport = "export:job:topup:deposit"
				localStorage.setItem("key_export_topup_deposit", keyExport)
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportTrack({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_topup_deposit")
			if (keyExport === null) {
				return resulter.errorResult()
			}
			let query = {
				key: keyExport
			}
			const res = await conn.get(depositAPI.export.track, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteCluster({commit}, key) {
		try {
			let query = {
				key: key
			}
			const res = await conn.get(depositAPI.export.delete.cluster, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteMaster({commit}) {
		// localStorage.removeItem("key_export_topup_deposit")
		try {
			let keyExport = localStorage.getItem("key_export_topup_deposit")
			let query = {
				key: keyExport
			}
			const res = await conn.get(depositAPI.export.delete.master, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.removeItem("key_export_topup_deposit")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	}
}

export default actions